import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React from "react";

export const CopyrightText: React.FC = () => {
    const currentYear = new Date().getFullYear();   
    const copytext= translate("Copyright © @year Dana Limited. All Rights Reserved").replace("@year",currentYear.toString())
    return (
        <div className="text-body-sm">
         {copytext}
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: CopyrightText,
    definition: {
        group: "Common",
        displayName: "Dana Copyright Text",
    },
};

export default widgetModule;